// Sales & Marketing Skills organized by subcategories
export const SALES_MARKETING_SKILLS_CATEGORIES = [
  {
    name: 'Sales Strategy',
    skills: [
      'Sales Planning', 'Territory Management', 'Pipeline Management',
      'Sales Forecasting', 'Account Strategy', 'Sales Analytics',
      'Market Analysis', 'Competitive Analysis', 'Sales Process',
      'Revenue Planning', 'Sales Goals', 'Performance Metrics',
      'Sales Tools', 'Sales Operations', 'Strategic Planning'
    ]
  },
  {
    name: 'Sales Techniques',
    skills: [
      'Consultative Selling', 'Solution Selling', 'Relationship Building',
      'Negotiation Skills', 'Closing Techniques', 'Presentation Skills',
      'Product Knowledge', 'Value Proposition', 'Objection Handling',
      'Cold Calling', 'Lead Generation', 'Customer Engagement',
      'Sales Psychology', 'Persuasion Skills', 'Communication Skills'
    ]
  },
  {
    name: 'Marketing Strategy',
    skills: [
      'Marketing Planning', 'Brand Strategy', 'Market Research',
      'Campaign Planning', 'Marketing Analytics', 'Target Marketing',
      'Positioning Strategy', 'Marketing Mix', 'Growth Strategy',
      'Market Analysis', 'Competitive Analysis', 'Marketing Goals',
      'Performance Metrics', 'Marketing Tools', 'Strategic Planning'
    ]
  },
  {
    name: 'Digital Marketing',
    skills: [
      'SEO', 'Social Media Marketing', 'Content Marketing',
      'Email Marketing', 'PPC Advertising', 'Analytics Tools',
      'Marketing Automation', 'Website Optimization', 'Digital Strategy',
      'Mobile Marketing', 'Online Advertising', 'Marketing Tools',
      'Performance Tracking', 'Digital Campaigns', 'Digital Analytics'
    ]
  },
  {
    name: 'Content Creation',
    skills: [
      'Content Strategy', 'Copywriting', 'Content Planning',
      'Content Management', 'Content Analytics', 'SEO Writing',
      'Brand Voice', 'Editorial Skills', 'Content Tools',
      'Visual Content', 'Content Distribution', 'Content Marketing',
      'Content Performance', 'Content Optimization', 'Content Standards'
    ]
  },
  {
    name: 'Brand Management',
    skills: [
      'Brand Strategy', 'Brand Development', 'Brand Guidelines',
      'Brand Identity', 'Brand Communication', 'Brand Analytics',
      'Brand Positioning', 'Brand Marketing', 'Brand Management',
      'Brand Performance', 'Brand Tools', 'Brand Standards',
      'Brand Experience', 'Brand Metrics', 'Brand Protection'
    ]
  },
  {
    name: 'Market Research',
    skills: [
      'Research Methods', 'Data Collection', 'Market Analysis',
      'Consumer Research', 'Competitive Analysis', 'Research Tools',
      'Data Analysis', 'Research Planning', 'Research Strategy',
      'Market Intelligence', 'Research Reports', 'Research Analytics',
      'Market Trends', 'Research Methods', 'Research Standards'
    ]
  },
  {
    name: 'Customer Relationship',
    skills: [
      'Account Management', 'Customer Service', 'Client Relations',
      'Customer Support', 'Customer Experience', 'Customer Analytics',
      'Customer Retention', 'Customer Success', 'Customer Strategy',
      'Customer Feedback', 'Customer Tools', 'Customer Standards',
      'Customer Journey', 'Customer Metrics', 'Customer Engagement'
    ]
  },
  {
    name: 'Marketing Analytics',
    skills: [
      'Data Analysis', 'Performance Metrics', 'Analytics Tools',
      'Marketing ROI', 'Campaign Analytics', 'Customer Analytics',
      'Digital Analytics', 'Analytics Strategy', 'Analytics Reports',
      'Data Visualization', 'Analytics Tools', 'Performance Tracking',
      'Analytics Standards', 'Analytics Methods', 'Analytics Planning'
    ]
  },
  {
    name: 'Product Marketing',
    skills: [
      'Product Strategy', 'Product Launch', 'Product Positioning',
      'Market Analysis', 'Product Analytics', 'Product Communication',
      'Product Training', 'Product Tools', 'Product Standards',
      'Product Performance', 'Product Planning', 'Product Marketing',
      'Product Experience', 'Product Metrics', 'Product Management'
    ]
  },
  {
    name: 'Event Marketing',
    skills: [
      'Event Planning', 'Event Management', 'Event Strategy',
      'Event Marketing', 'Event Analytics', 'Event Coordination',
      'Event Promotion', 'Event Tools', 'Event Standards',
      'Event Performance', 'Event Metrics', 'Event Experience',
      'Event Operations', 'Event Planning', 'Event Execution'
    ]
  },
  {
    name: 'Marketing Technology',
    skills: [
      'Marketing Software', 'CRM Systems', 'Marketing Automation',
      'Analytics Tools', 'Digital Platforms', 'Technology Strategy',
      'Technology Implementation', 'Marketing Tools', 'Technology Standards',
      'Technology Performance', 'Technology Planning', 'Technology Integration',
      'Technology Analytics', 'Technology Management', 'Technology Support'
    ]
  }
];

// Export flattened list for backward compatibility
export const SALES_MARKETING_SKILLS = SALES_MARKETING_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
